import React from "react";

export function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center text-center py-14 px-6">
      <div className="w-16 h-16 rounded-2xl hero-gradient flex items-center justify-center mb-4 border border-[color:var(--glass-border)]">
        {Icon && <Icon className="w-7 h-7 text-[color:var(--brand-ocean)]" />}
      </div>
      <h3 className="font-display text-lg text-[color:var(--ink)]">{title}</h3>
      {description && <p className="text-sm text-[color:var(--ink-3)] mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
